import { JoinView } from "../features/join/JoinView";

export const JoinPage = JoinView;
